import React from 'react'

export const Title = () => {
  return (
    <h1 className='text-white mt-5'>Simon Says</h1>
  )
}
